let search_mask = (where, text) => {
    var markInstance = new Mark(where);
    let input_value = text;
    var options = {};
    markInstance.unmark({
        done: function () {
            markInstance.mark(input_value, options);
        },
    });
};

export default search_mask;
